import React from 'react';

const cardsData = [
  {
    id: 'lead-gen',
    title: 'Lead Generation',
    description:
      'Experts Communication is your best partner for lead generation. We use our BPO services in Karachi to bring high quality leads to our clients. If you have quality leads, you can close more deals.',
    topIcon: (
      <svg width="52" height="52" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="8" width="36" height="26" rx="4" stroke="#e2e8f0" strokeWidth="2.5" />
        <path d="M12 16H20" stroke="#e2e8f0" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M12 22H24" stroke="#e2e8f0" strokeWidth="2.5" strokeLinecap="round" />
        <rect x="28" y="14" width="10" height="12" rx="2" stroke="#c40a0a" strokeWidth="2" />
        <circle cx="33" cy="18" r="1.5" fill="#c40a0a" />
        <path d="M30 24L32 22L36 25" stroke="#c40a0a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M18 34L14 40H34L30 34" stroke="#e2e8f0" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    cornerIcon: (
      <svg width="120" height="120" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="corner-svg">
        {/* Person working at desk/laptop illustration matching user screenshot */}
        <circle cx="50" cy="25" r="10" stroke="#ffffff" strokeWidth="3" />
        <path d="M43 23C43 23 46 27 50 27C54 27 57 23 57 23" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M30 55C30 45 40 40 50 40C60 40 70 45 70 55V68H30V55Z" stroke="#ffffff" strokeWidth="3" />
        {/* Laptop & Arms */}
        <path d="M28 58L42 70L58 70L72 58" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M36 70L50 54L64 70" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 88L25 88L35 78L45 88L65 78L75 88L90 88" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  {
    id: 'data-enrichment',
    title: 'Data Enrichment and Validation',
    description:
      'We verify contact information, add relevant details, and segment leads for better targeting. Experts Communication improves your existing lead databases. The campaigns reach the right audience with correct and current information.',
    topIcon: (
      <svg width="52" height="52" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="21" cy="21" r="14" stroke="#e2e8f0" strokeWidth="2.5" />
        <path d="M31 31L42 42" stroke="#e2e8f0" strokeWidth="3" strokeLinecap="round" />
        <circle cx="21" cy="21" r="6" stroke="#c40a0a" strokeWidth="2.5" />
        <path d="M21 11V13M21 29V31M11 21H13M29 21H31" stroke="#c40a0a" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    ),
    cornerIcon: (
      <svg width="120" height="120" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="corner-svg">
        <circle cx="50" cy="24" r="10" stroke="#ffffff" strokeWidth="3" />
        <path d="M32 54C32 44 41 40 50 40C59 40 68 44 68 54V68H32V54Z" stroke="#ffffff" strokeWidth="3" />
        <circle cx="70" cy="62" r="12" stroke="#c40a0a" strokeWidth="3" fill="#000000" />
        <path d="M78 70L88 80" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" />
        <path d="M66 62L69 65L75 59" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 88L30 88L42 78L58 88L72 78L88 88" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  {
    id: 'efficient-working',
    title: 'Efficient Working',
    description:
      'We handle large volumes of data with accuracy and speed. You don’t have to invest your time in administrative tasks; we will do them for you. We speed up your operation and bring strategic growth to your business.',
    topIcon: (
      <svg width="52" height="52" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="26" width="7" height="14" rx="1.5" stroke="#e2e8f0" strokeWidth="2.5" />
        <rect x="19" y="18" width="7" height="22" rx="1.5" stroke="#e2e8f0" strokeWidth="2.5" />
        <rect x="30" y="10" width="7" height="30" rx="1.5" stroke="#c40a0a" strokeWidth="2.5" fill="rgba(196, 10, 10, 0.15)" />
        <path d="M26 10L33.5 2.5L41 10" stroke="#c40a0a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M33.5 3V12" stroke="#c40a0a" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    ),
    cornerIcon: (
      <svg width="120" height="120" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="corner-svg">
        <circle cx="50" cy="24" r="10" stroke="#ffffff" strokeWidth="3" />
        <path d="M32 54C32 44 41 40 50 40C59 40 68 44 68 54V68H32V54Z" stroke="#ffffff" strokeWidth="3" />
        {/* Speed / Rocket / Success Growth Accent */}
        <path d="M25 45L15 35M20 55L8 50M24 65L12 65" stroke="#c40a0a" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M42 70L50 56L58 70" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 88L28 88L40 78L56 88L70 78L88 88" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
];

function BpoFeaturesCards() {
  return (
    <section className="bpo-cards-section">
      <div className="container">
        <div className="bpo-cards-grid">
          {cardsData.map((card) => (
            <div key={card.id} className="bpo-feature-card">
              {/* Top Icon */}
              <div className="bpo-card-top-icon">
                {card.topIcon}
              </div>

              {/* Title */}
              <h3 className="bpo-card-title">
                {card.title}
              </h3>

              {/* Description */}
              <p className="bpo-card-desc">
                {card.description}
              </p>

              {/* Bottom Right Hover Animated Illustration */}
              <div className="bpo-card-corner-icon">
                {card.cornerIcon}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BpoFeaturesCards;
